import { http } from './http';

export async function listDdMembers(params = {}) {
  const { data } = await http.get('book/volunteer-brigade/', { params });
  return data;
}

export async function getDdMember(id) {
  const { data } = await http.get(`book/volunteer-brigade/${id}/`);
  return data;
}

export async function createDdMember(payload) {
  const { data } = await http.post('book/volunteer-brigade/', payload);
  return data;
}

export async function updateDdMember(id, payload) {
  const { data } = await http.patch(`book/volunteer-brigade/${id}/`, payload);
  return data;
}

export async function deleteDdMember(id) {
  const { data } = await http.delete(`book/volunteer-brigade/${id}/`);
  return data;
}

